import JotformPage from "@components/Jotform/JotformPage";
import Loading from "@components/layout/Loading";
import getFormId from "@utils/forms";
import { useCurrentUserMutation } from "@utils/hooks";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

type FactFindProps = {};

const FactFindPersonalDetails: React.FC<FactFindProps> = () => {
  const navigate = useNavigate();
  const { mutate, isLoading, isSuccess, error } = useCurrentUserMutation();
  const [submitting, setSubmitting] = useState(false);
  const hasSubmittedRef = useRef(false);
  const navigationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleFormSubmit = () => {
    if (hasSubmittedRef.current) return;

    console.log("FactFindPersonalDetails: Form submitted");
    hasSubmittedRef.current = true;
    setSubmitting(true);

    // Update the database
    mutate({
      form_fact_find_personal_details: true,
    });

    // Set a safety timeout for navigation
    navigationTimeoutRef.current = setTimeout(() => {
      console.log("FactFindPersonalDetails: Navigation timeout triggered");
      navigate("/fact-find");
    }, 3000);
  };

  useEffect(() => {
    if (error) {
      console.error("FactFindPersonalDetails: Error submitting form", error);
      setSubmitting(false);
      hasSubmittedRef.current = false;
    }

    if (!isLoading && isSuccess && hasSubmittedRef.current) {
      console.log("FactFindPersonalDetails: Submission successful, navigating");
      navigate("/fact-find");
    }
  }, [isSuccess, isLoading, navigate, error]);

  // Clean up on unmount
  useEffect(() => {
    return () => {
      if (navigationTimeoutRef.current) {
        clearTimeout(navigationTimeoutRef.current);
      }
    };
  }, []);

  if (isLoading || submitting) {
    return <Loading />;
  }

  return (
    <JotformPage
      formId={getFormId("fact_find_personal_details")}
      onSubmit={handleFormSubmit}
    />
  );
};

export default FactFindPersonalDetails;